import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, LabelList } from 'recharts';

const PdfHorizontalStackedBarChart = ({ 
  data = [], 
  xAxisLabel = 'X Axis', 
  yAxisLabel = 'Y Axis', 
  colors = {
    participated: '#76C8E8',
    created: '#003C73',
    validated: '#B0EAC0'
  },
  height = 400,
  domain = [0, 100],
  ticks = [0, 20, 40, 60, 80, 100],
  visibleBars = null,
  selectedFilters = ['All'],
  showLegend = true
}) => {
  // Calculate dynamic height based on number of bars to fit all data without scrolling
  const barCount = visibleBars || data.length;
  const calculatedHeight = Math.max(height, barCount * 24 + 100);
  
  // Get the keys for stacked data (participated, created, validated)
  const stackKeys = Object.keys(colors);
  
  // Wrap long Y-axis tick labels onto multiple lines
  const renderWrappedYAxisTick = (props) => {
    const { x = 0, y = 0, payload } = props || {};
    const text = payload?.value ?? '';
    if (!text) return null;
    const words = String(text).split(' ').filter(Boolean);
    const lines = [];
    const maxWordsPerLine = 2;
    for (let i = 0; i < words.length; i += maxWordsPerLine) {
      lines.push(words.slice(i, i + maxWordsPerLine).join(' '));
    }
    const lineHeight = 12;
    const totalHeight = lineHeight * (lines.length - 1);
    return (
      <text x={x - 5} y={y - totalHeight / 2} textAnchor="end" fill="#374151" fontSize="11">
        {lines.map((line, idx) => (
          <tspan key={idx} x={x - 5} dy={idx === 0 ? 0 : lineHeight}>{line}</tspan>
        ))}
      </text>
    );
  };

  if (!data || data.length === 0) {
    return (
      <div className="w-full flex items-center justify-center text-gray-500" style={{ height: `${height}px` }}>
        <div className="text-sm">No data available</div>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col h-full">
      <div style={{ flex: 1, width: '100%' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            layout="vertical"
            data={data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 40,
            }}
          >
            <XAxis 
              type="number" 
              domain={domain}
              ticks={ticks}
              label={{ value: xAxisLabel, position: 'bottom', offset: 10 }}
            />
            <YAxis 
              dataKey="name" 
              type="category" 
              width={150}
              tick={renderWrappedYAxisTick}
              tickMargin={8}
              label={{ value: yAxisLabel, angle: -90, position: 'insideLeft', offset: 0 }}
            />
            
            {stackKeys.map((key) => (
              <Bar 
                key={key}
                dataKey={key} 
                stackId="stack"
                fill={colors[key]}
                barSize={20}
              >
                <LabelList 
                  dataKey={key}
                  position="center"
                  fill="white"
                  fontSize={10}
                  fontWeight="bold"
                  formatter={(value) => value > 0 ? value : ''}
                />
              </Bar>
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
      
      {/* Compact Legend */}
      {/* {showLegend && (
        <div className="mt-2 px-2" style={{ minHeight: '25px' }}>
          <div className="flex justify-center gap-4">
            {stackKeys.map((key) => (
              <div key={key} className="flex items-center gap-1">
                <div 
                  className="w-2 h-2 rounded"
                  style={{ backgroundColor: colors[key] }}
                ></div>
                <span className="text-xs capitalize">{key}</span>
              </div>
            ))}
          </div>
        </div>
      )} */}
    </div>
  );
};

export default PdfHorizontalStackedBarChart;
